var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('font-awesome-icon',{staticClass:"fa-spin",attrs:{"far":"","icon":['fad', 'spinner']}}):_vm._e(),(_vm.priceObject !== null && !_vm.loading)?_c('span',[_vm._v(" € "+_vm._s(_vm.price)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }